import { LoadableCompanies } from "features";
import React from "react";
import { Breadcrumb } from "shared/ui/components";

export default function CompaniesPage() {
  return (
    <>
      <Breadcrumb />
      <LoadableCompanies />
    </>
  );
}
